window.renderFileName = function(file_field){
  $('#file-name').text(file_field.files.item(0).name.replace(/ /g,"_"));
}